import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 30000 });

export const formatEur = (v) =>
  new Intl.NumberFormat("ru-RU", { style: "currency", currency: "EUR", minimumFractionDigits: 2 }).format(v || 0);

export const errorMessage = (e, fallback = "Что-то пошло не так. Попробуйте ещё раз.", fieldsMsg = "Проверьте правильность заполнения полей.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d) && d.length) return fieldsMsg;
  return fallback;
};

const readJSON = (key, fallback) => {
  try {
    const v = JSON.parse(localStorage.getItem(key) || "null");
    return v ?? fallback;
  } catch {
    return fallback;
  }
};

const CART_KEY = "rpm_cart_v1";
export const loadCart = () => {
  const v = readJSON(CART_KEY, []);
  return Array.isArray(v) ? v : [];
};
export const saveCart = (items) => localStorage.setItem(CART_KEY, JSON.stringify(items));
export const clearCart = () => localStorage.removeItem(CART_KEY);

const CHECKOUT_KEY = "rpm_checkout_v1";
export const loadCheckout = () => readJSON(CHECKOUT_KEY, {}) || {};
export const saveCheckout = (v) => localStorage.setItem(CHECKOUT_KEY, JSON.stringify(v));

// Individual frames: every pair costs pair_price (22 €), a leftover single costs price (12 €)
export const priceFor = (product, qty) => {
  if (!product) return 0;
  if (product.pair_price) return Math.floor(qty / 2) * product.pair_price + (qty % 2) * product.price;
  return qty * product.price;
};

// Cart totals: pair discount counted across the whole cart (same rule as the server)
export const cartTotals = (cart, products = []) => {
  const gross = cart.reduce((s, it) => s + it.unit_price * it.quantity, 0);
  const qtyBy = {};
  cart.forEach((it) => (qtyBy[it.product_id] = (qtyBy[it.product_id] || 0) + it.quantity));
  let subtotal = 0;
  Object.entries(qtyBy).forEach(([pid, q]) => {
    const p = products.find((x) => x.id === pid);
    subtotal += p ? priceFor(p, q) : 0;
  });
  return { gross, subtotal, discount: Math.max(0, Math.round((gross - subtotal) * 100) / 100) };
};
